export type ReactAppEnvironment = 'development' | 'staging' | 'production';

export const REACT_APP_ENVIRONMENT: ReactAppEnvironment = (process.env.REACT_APP_ENV as ReactAppEnvironment | undefined) ?? 'development';